import moment from 'moment';
import getItemStyles from '../../../utils/item-styles';
import getOffsetTime from '../../../../../utils/getOffsetTime';
import timelineDisplayOrder from './timelineDisplayOrder';

/**
 * Returns a formatted day off item for the one to two day posted schedule.
 * @param {*} resource
 * @param {*} dayType
 */
const generateOffTimeRequest = (resource, dayType) => {
  const { rId } = resource;
  const { dayOffRequest } = dayType;
  const { dorId, abbreviation, dayOffRequestTitle, startTime, endTime, dayTypeComment, myDayTypeComment,isApproved,wbse,showCostObjectId,costCenter } = dayOffRequest;
  let hasComment = false;
  if (myDayTypeComment) {
    hasComment = true;
  }
  const offtimeStyle = getItemStyles('dayOffRequest');  // TODO: update
  const momentStartTime = moment.unix(startTime);
  const offsetTime = getOffsetTime(momentStartTime._d);
  const offsetStartTime = moment(momentStartTime).add(offsetTime, 'minutes');
  const offsetEndTime = moment.unix(endTime).add(offsetTime, 'minutes');
  const offTimeRequest = {
    id: dorId,
    itemType: 'off-request',
    group: rId,
    dorId,
    title: dayOffRequestTitle || `Days off request: ${abbreviation}`,  // postedSched || liveSched
    start_time: offsetStartTime.startOf('day'),
    end_time: offsetEndTime.endOf('day'), // Note: using 'offsetEndTime.startOf' causes dayOffRequests to have 0 duration and barely be visible
    dayTypeComment,
    myDayTypeComment,
    backgroundColor: offtimeStyle.backgroundColor,
    color: offtimeStyle.color,
    borderStyle: offtimeStyle.borderStyle,
    borderColor: hasComment ? "red" : offtimeStyle.borderColor,
    timelineDisplayOrder: timelineDisplayOrder.dayOffRequest,
    isApproved,
    wbse,
    showCostObjectId,
    costCenter
  };
  return offTimeRequest;
}

export default generateOffTimeRequest;



// WEBPACK FOOTER //
// ./src/Components/Schedule/OneTwoDay/utils/generate-timeline/generateOffTimeRequests.js